<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options" [isValid]="canSave()">
  <div class="company-editor-container editor-container">
    <form class="company-form admin-form">
      <shared-ui-text-input label="Name" [control]="form?.name"></shared-ui-text-input>
      <shared-ui-textarea label="Description" [control]="form?.description"></shared-ui-textarea>
      <shared-ui-checkbox label="Active" [control]="form?.isActive"></shared-ui-checkbox>
    </form>
  </div>
</app-modal-wrapper>
